import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from 'react-hook-form';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs/selectors';

import { OccupationType } from '@/types/form';

import { Select } from '../Select';

interface EmploymentOccupationSelectionProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  occupationType?: OccupationType;
  label?: string;
}
export const EmploymentOccupationSelection = <T extends FieldValues>({
  name,
  control,
  occupationType = 'Employee',
  label,
}: EmploymentOccupationSelectionProps<T>) => {
  const { t } = useTranslate();
  const { occupations, directorOccupations } =
    useAppSelector(selectConfigsState);

  const {
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <Select
      options={
        occupationType === 'Director' ? directorOccupations : occupations
      }
      control={control}
      name={name}
      error={!!error}
      helperText={error?.message}
      rules={{
        required: t('employerForm.form.occupationCode.required'),
      }}
      fullWidth
      label={label}
      placeholder={t('employerForm.form.occupationCode.placeholder')}
      useDrawerOnMobile
      withSearchBar
    />
  );
};
